// 基于el-dialog封装的dialog组件
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'dElDialog'
})
export default class DElDialog extends Vue {
    // 弹框显示状态
    @Prop({ default: false }) dialogShow: boolean
    // 标题
    @Prop({ default: '提示' }) title: string

    // 弹框确认
    dialogConfirm() {
        this.$emit('confirm')
    }

    // 弹框取消
    dialogCancle() {
        this.dialogShow = false
        this.$emit('update: dialogShow', false)
    }
}